import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
import { getDetailRecord } from '@/containers/content/util'
import { AnswerDetails } from '@/components'

const { WizContainer, modelUtils } = framework_tool;
const { WizSpin, WizCard, WizAlert, WizRow, WizCol, WizTable, WizModal, WizSearchBar, WizCollapse, WizDataTable } = component_tool;

class PracticePaperInfo extends WizContainer {
  componentName = 'PracticePaperInfo';

  constructor(props) {
    super(props);
    this.detailInfo = getDetailRecord(props.history);
    this.state = {
      paperId: this.detailInfo.id,
      record: this.detailInfo,
      data: {}
    };
  }

  _componentDidMount = () => {
    let { paperId } = this.state
    this.doAction({
      path: 'practiceRecord/getDetailByPaperId',
      payload: {
        key: 'practicePaperDetail',
        apiParams: { paperId }
      }
    })
  }

  propsAndStateOnChange = {
    practicePaperDetail: this._practicePaperDetailOver.bind(this)
  }

  _practicePaperDetailOver(nextProps, nextState) {
    let { practicePaperDetail } = nextProps
    if (practicePaperDetail && practicePaperDetail['success']) {
      nextState.data = practicePaperDetail['data']
    } else {
      wizNotice.error(practicePaperDetail && practicePaperDetail['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _render() {
    let { practiceRecordLoading } = this.props
    let { data } = this.state
    return (
      <>
        <AnswerDetails data={data}></AnswerDetails>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { practiceRecord } = state;
  const practicePaperDetail = modelUtils.getModelEntity(practiceRecord, 'practicePaperDetail');
  const load = modelUtils.getLoadingState(state, 'practiceRecord');
  return {
    practicePaperDetail,
    ...load,
  };
};

export default connect(mapStateToProps)(PracticePaperInfo);
